//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  props: {
    index: Number,
    category: Object
  },
  methods: {
    ...mapMutations({
      setWebinarsAccordionIndex: 'webinars/setAccordionIndex'
    })
  }
}
